import Image from 'next/image';
import { motion, type HTMLMotionProps } from 'framer-motion';

import { cn } from '#/lib/utils';

import image from './images/squashed-circle.png';

export function SquashedCircle({
  className,
  ...props
}: HTMLMotionProps<'div'>) {
  return (
    <motion.div {...props} className={cn(className)}>
      <Image
        {...image}
        alt="Squashed Circle"
        className="w-full h-full object-cover"
      />
    </motion.div>
  );
}
